import { render, staticRenderFns } from "./InactiveTradieSection.vue?vue&type=template&id=68b3fac9&scoped=true"
import script from "./InactiveTradieSection.vue?vue&type=script&lang=js"
export * from "./InactiveTradieSection.vue?vue&type=script&lang=js"
import style0 from "./InactiveTradieSection.vue?vue&type=style&index=0&id=68b3fac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b3fac9",
  null
  
)

export default component.exports